import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import _ from 'lodash';
import Avatar from 'material-ui/Avatar';
import PropTypes from 'prop-types';
import { Component, default as React } from 'react';
import { colorsV2 } from '../../styles/colors';
import Checkbox from '@material-ui/core/Checkbox';
import { FormControlLabel, FormGroup } from '@material-ui/core';

const style = {
	container: {
		marginTop: 20,
	},
	searchContainer: {
		width: "100%",
		display: "flex",
		flexDirection: "row",
	}
}

class UsersList extends Component {
	constructor(props) {
		super(props);

		this.state = {
			users: props.users,
			searchTerm: '',
			selectAll: false
		}
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			users: nextProps.users,
			searchTerm: '',
		})
	}

	searchBar() {
		return (
			<div style={style.searchContainer}>
				<TextField
					fullWidth
					placeholder="Search..."
					color={colorsV2.primary}
					variant="outlined"
					value={this.state.searchTerm}
					onChange={(event) => { this.setState({ searchTerm: event.target.value }) }}
					InputProps={{
						startAdornment:
							<InputAdornment position="start">
								<SearchIcon color={colorsV2.primary} />
							</InputAdornment>,
					}}
				/>
			</div>
		)
	}

	isSelected(user) {
		return this.props.selectedUsers && this.props.selectedUsers.includes(user) ? true : false;
	}

	userListItem(user) {
		let userName = user.userInfo.lastName ? `${user.userInfo.firstName} ${user.userInfo.lastName}` : user.userInfo.email;
		let deleteUser = this.props.allowRemove ? () => { this.props.onDelete(user, userName) } : null;
		return (
			<ListItem
				divider
				key={user.id}
				selected={this.isSelected(user)}
				onClick={() => {
					this.isSelected(user) ? deleteUser() : this.props.onClick(user)
				}}
			>
				<ListItemAvatar>
					<Avatar size={32} src={user.userInfo.profilePhotoUrl} />
				</ListItemAvatar>
				<ListItemText primary={userName} />
			</ListItem>
		);
	}

	userList() {
		let users = [];
		_.values(this.state.users).forEach((user) => {
			if (this.state.searchTerm === '') {
				users.push(this.userListItem(user));
			} else {
				let userName = user.userInfo.lastName ? `${user.userInfo.firstName} ${user.userInfo.lastName}` : user.userInfo.email;
				if (userName.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) === -1) {
					return;
				}
				users.push(this.userListItem(user));
			}
		})
		return (
			<List>
				{users}
			</List>
		)
	}

	render() {
		return (
			<div style={style.container}>
				{this.searchBar()}
				{this.userList()}
				<FormGroup>
					<FormControlLabel
						control={
							<Checkbox
								defaultChecked
								color="primary"
								inputProps={{ 'aria-label': 'Select All' }}
								checked={this.state.selectAll}
								onChange={(event) => {
									this.setState({ selectAll: event.target.checked })
									if (event.target.checked) {
										this.props.onSelectAll(this.state.users)
									} else {
										this.props.onSelectAll([])
									}
								}}

							/>
						}
						label={"Select All"}
					/>
				</FormGroup>

			</div>
		);
	}
}

UsersList.propTypes = {
	users: PropTypes.array.isRequired,
	onClick: PropTypes.func,
	allowRemove: PropTypes.bool,
	onDelete: PropTypes.func,
};

export default UsersList;



// WEBPACK FOOTER //
// ./src/components/common/UsersListV2.js